export const vehicleBrand = [
  // 🏍️ Two Wheelers (Bikes & Scooters)
  { label: "Honda", value: "Honda" },
  { label: "Yamaha", value: "Yamaha" },
  { label: "Suzuki", value: "Suzuki" },
  { label: "Hero", value: "Hero" },
  { label: "Bajaj", value: "Bajaj" },
  { label: "TVS", value: "TVS" },
  { label: "Royal Enfield", value: "Royal Enfield" },
  { label: "KTM", value: "KTM" },
  { label: "Benelli", value: "Benelli" },
  { label: "CFMoto", value: "CFMoto" },
  { label: "Aprilia", value: "Aprilia" },
  { label: "Kawasaki", value: "Kawasaki" },
  { label: "Harley-Davidson", value: "Harley-Davidson" },
  { label: "BMW Motorrad", value: "BMW Motorrad" },
  { label: "Vespa", value: "Vespa" },
  { label: "Peugeot", value: "Peugeot" },
  { label: "UM Motorcycles", value: "UM Motorcycles" },
  { label: "Husqvarna", value: "Husqvarna" },

  // 🚗 Cars / SUVs
  { label: "Toyota", value: "Toyota" },
  { label: "Hyundai", value: "Hyundai" },
  { label: "Maruti Suzuki", value: "Maruti Suzuki" },
  { label: "Tata", value: "Tata" },
  { label: "Mahindra", value: "Mahindra" },
  { label: "Nissan", value: "Nissan" },
  { label: "Ford", value: "Ford" },
  { label: "Kia", value: "Kia" },
  { label: "Volkswagen", value: "Volkswagen" },
  { label: "Skoda", value: "Skoda" },
  { label: "Renault", value: "Renault" },
  { label: "Chevrolet", value: "Chevrolet" },
  { label: "MG", value: "MG" },
  { label: "Chery", value: "Chery" },
  { label: "Geely", value: "Geely" },
  { label: "Great Wall (GWM)", value: "Great Wall" },

  // ⚡ Electric Vehicles (EV)
  { label: "BYD", value: "BYD" },
  { label: "Tesla", value: "Tesla" },
  { label: "Neta", value: "Neta" },
  { label: "Dongfeng", value: "Dongfeng" },
  { label: "Wuling", value: "Wuling" },
  { label: "Seres", value: "Seres" },

  // 🚐 Commercial / Utility
  { label: "Isuzu", value: "Isuzu" },
  { label: "Ashok Leyland", value: "Ashok Leyland" },
  { label: "Eicher", value: "Eicher" },
  { label: "Force Motors", value: "Force Motors" },

  // 🌍 Luxury
  { label: "BMW", value: "BMW" },
  { label: "Mercedes-Benz", value: "Mercedes-Benz" },
  { label: "Audi", value: "Audi" },
  { label: "Lexus", value: "Lexus" },
  { label: "Volvo", value: "Volvo" },

  // ❓ Fallback
  { label: "Other", value: "Other" },
];
